export default [
    {
      title: 'Create Azure DevOps work item',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'Link Azure DevOps work item',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'Notify Azure DevOps work item',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'View Work Item History and status',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'Unlink Work Item',
      plus: '-',
      pro: '-',
      premium: '<i class="fas fa-check text-success">'
    },
    {
      title: 'Users access',
      plus: '<span class="text-sm text-light">Valid upto 5 users</span>',
      pro: '<span class="text-sm text-light">Valid upto unlimited users</span>',
      premium: '<span class="text-sm text-light">Valid upto 10 users</span>'
    },
    {
      title: 'Work Items Count',
      plus: '<span class="text-sm text-light">Valid upto 100 work items</span>',
      pro: '<span class="text-sm text-light">Valid upto 20 work items/agent/month</span>',
      premium: '<span class="text-sm text-light">Valid upto 300 work items</span>'
    },
    {
      title: '24*7 SLA support',
      plus: '<span class="text-sm text-light">Limited Support</span>',
      pro: '<span class="text-sm text-light">Limited Support</span>',
      premium: '<i class="fas fa-check text-success">'
    },
    {
      title: 'Access to projects',
      plus: '<span class="text-sm text-light">Valid upto 5 projects</span>',
      pro: '<span class="text-sm text-light">Valid upto 5 projects</span>',
      premium: '<span class="text-sm text-light">Valid upto 20 projects</span>',
    },
    {
      title: 'Custom work item types',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+30$ per month)</span>'
    },
    {
      title: 'Custom fields',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Two-way Comment Sync',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+50$ per month)</span>'
    },
    {
      title: 'DevOps Sync Status (Only Closed or Done)',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+20$ per month)</span>'
    },
    {
      title: 'DevOps Sync all Status (DevOps status change will be posted as internal note)',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Freshservice Change Requests Integration',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Work Item Search',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Upload Files',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+20$ per month)</span>'
    },
    {
      title: 'Customize View',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'On-Premise Support',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Multiple Azure Devops Tenants/Organizations Support',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    },
    {
      title: 'Automatically Create ADO Work Item from Zendesk/Freshdesk/Freshservice  ',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    },
    {
      title: 'Automatically Create Zendesk/Freshdesk/Freshservice from ADO Work Item',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    },
    {
      title: 'Sync All Comments Log (The Comments which was made before the ADO Work Item Creation/Linking)',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Multiple Brands Support',
      plus: '-',
      pro: '<span class="text-sm text-light">Contact Sales for Price</span>',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    },
    {
      title: 'Mapping of Users by Email in Service desk and Azure DevOps',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Parent/Child Work Item Relations',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Advance Customization',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    }

];